import { Component } from '@mycolorway/tao';
import flatpickr from 'next/javascripts/modules/flatpickr';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

export default Component('tr-date-picker-field-result', {
  mixins: [eventListenerMixin],

  properties: {
    displayFormat: {
      type: String,
      default: 'Y-m-d',
    },

    selected: {
      type: Boolean,
      default: false,
      observer() {
        if (this.selectedChanged) this.selectedChanged();
      },
    },
  },

  ready() {
    this.selectedText = this.querySelector('.selected-text');
    this.addEventListeners();
  },

  disconnected() {
    this.stopListening();
  },

  addEventListeners() {
    this.listenTo(this.selectedText, 'click', () => {
      this.namespacedTrigger('activeClick');
    });
  },

  setSelected(dates) {
    if (!dates || dates.length === 0) {
      this.clearSelected();
    } else {
      this.selected = true;
      this.selectedText.textContent = dates
        .map(date => flatpickr.formatDate(date, this.displayFormat))
        .join(flatpickr.defaultConfig.locale.rangeSeparator);
    }
  },

  clearSelected() {
    this.selected = false;
    this.selectedText.textContent = '';
  },
});
